import { type FC } from 'react'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { type ContactFormState } from '../../../../contact-form'
import { type OpenableControls } from '../../../../generic-hooks'
import { useDirectFormDialogContext } from '../DirectContactFormDialogContext'

import { DirectContactFormOrderSelectionDialogContent } from './DirectContactFormOrderSelectionDialogContent'

export const DirectContactFormOrderSelectionDialog: FC<{
  formState: ContactFormState
  modalControls: OpenableControls
}> = ({ formState, modalControls }) => {
  const { orderSelectionDialogTitle } = useDirectFormDialogContext()

  return (
    <Dialog onClose={modalControls.handleClose} open={modalControls.isOpen}>
      <DialogTitle onClose={modalControls.handleClose}>
        {orderSelectionDialogTitle}
      </DialogTitle>
      <DialogContent className="flex h-full flex-col items-center gap-2 p-4">
        <DirectContactFormOrderSelectionDialogContent
          formState={formState}
          modalControls={modalControls}
        />
      </DialogContent>
    </Dialog>
  )
}
